import React from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  Routes,
  Route,
  useMatch,
  useSearchParams,
} from "react-router-dom";

import Measurement from '../pages/Modules/Custom/MoistureSensor/form/Measurement';
import Calibration from '../pages/Modules/Custom/MoistureSensor/form/Calibration';
import Correction from '../pages/Modules/Custom/MoistureSensor/form/Correction';
import ChannelParameter from '../pages/Modules/Custom/MoistureSensor/form/ChannelParameter';
import SystemParameter from '../pages/Modules/Custom/MoistureSensor/form/SystemParameter';
import Memory from '../pages/Modules/Custom/MoistureSensor/form/Memory';
import ZeroAdjust from '../pages/Modules/Custom/MoistureSensor/form/ZeroAdjust';
import Settings from '../pages/Modules/Custom/MoistureSensor/form/Settings';

const MoistureSensorRouter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const propsData = { location, navigate, params };

  const dynamicRouteRender = (routes) => {
    return (
      routes &&
      Array.isArray(routes) &&
      routes.map((route, index) => (
        <Route key={index} {...route} />
      ))
    );
  };
  const routes = [
    { path: "/Measurement", element: <Measurement {...propsData} /> },
    { path: "/Calibration", element: <Calibration {...propsData} /> },
    { path: "/Correction", element: <Correction {...propsData} /> },
    { path: "/ChannelParameter", element: <ChannelParameter {...propsData} /> },
    { path: "/SystemParameter", element: <SystemParameter {...propsData} /> },
    { path: "/Memory", element: <Memory {...propsData} /> },
    { path: "/ZeroAdjust", element: <ZeroAdjust {...propsData} /> },
    { path: "/Settings", element: <Settings {...propsData} /> },
  ];
  return (
    <div>
      <Routes>{dynamicRouteRender(routes)}</Routes>
    </div>
  );
};

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    let searchParams = useSearchParams();
    let match = useMatch(location.pathname);
    let router = { location, navigate, params, match, searchParams };
    return (
      <Component
        {...props}
        {...router}
      />
    );
  }
  return ComponentWithRouterProp;
}

export default withRouter(MoistureSensorRouter);